module.exports = function orderByTime(eventGroup){
    eventGroup.events.sort((eventA, eventB)=>{
        return eventA.start - eventB.start;
    });
    
    return eventGroup;
}